import React, {useState, useEffect} from 'react';
import Cookies from 'js-cookie';
import _decode from 'jwt-decode';

import {getEnvironment, isInternal} from '@albert-io/environment';
import {Banner, Button, Dialogue, Text} from '@albert-io/atomic';
import {upperFirst} from 'lib/stringUtils';

import {resource} from '@albert-io/json-api-framework/request/builder';
import {invalidatePartialInterest} from 'resources/mandark.resource';

interface Props {
  className: string;
  handleClose: () => void;
  classroomId: string;
}

const ImportRosterSuccess = ({className, handleClose, classroomId}: Props) => {
  const [lmsName, setLmsName] = useState('LMS');

  useEffect(() => {
    const launchContextCookie = Cookies.get('lti_launch_context');
    const launchContextDecoded = _decode(launchContextCookie);
    const lmsPlatformName = launchContextDecoded.tool_platform_product_family_code || 'LMS';
    setLmsName(upperFirst(lmsPlatformName));
  }, [setLmsName]);

  useEffect(() => {
    const classroomStudentsResource = resource('classrooms_v1')
      .mandarkEndpoint(['classrooms_v1', classroomId, 'students_v2'])
      .done();
    invalidatePartialInterest(classroomStudentsResource);

    const classroomInvitationResource = resource('classroom_invitations_v1')
      .mandarkEndpoint(['classroom_invitations_v1'])
      .done();
    invalidatePartialInterest(classroomInvitationResource);

    let cookieDomain = 'albert.io';
    if (isInternal()) {
      cookieDomain = getEnvironment();
    }

    Cookies.remove('lti_launch_context', {domain: cookieDomain});
  }, [classroomId]);

  return (
    <Dialogue hideCloseBtn className={className} size='m' title='Roster successfully imported.'>
      <Dialogue.Body>
        <div className='u-display_flex u-flex-direction_column'>
          <Text>Your roster was imported successfully!</Text>

          <Banner className=' u-mar-lr_auto u-mar-t_3 u-display_flex u-justify-content_center'>
            <Banner.Icon icon='info-circle' iconStyle='regular' className='u-align-self_center' />
            <Text>
              If you intend to import more classes from {lmsName}, you’ll need to launch into Albert
              from each of the courses you’d like to import.
            </Text>
          </Banner>
        </div>
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button onClick={() => handleClose()}>Dismiss</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

export default ImportRosterSuccess;
